/**
 * Keep in sync with benchling/procedures/platform/configs/feature_options.py
 */

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';

export enum ProcedurePlatformFeature {
  HAS_PRE_RUN_STEP = 'HAS_PRE_RUN_STEP',
  HAS_RUN_STEP = 'HAS_RUN_STEP',
  HAS_POST_RUN_STEP = 'HAS_POST_RUN_STEP',
}

type FeatureConfigDict = {
  [feature in ProcedurePlatformFeature]: boolean;
};

const DEFAULT_FEATURE_CONFIGS: FeatureConfigDict = {
  HAS_PRE_RUN_STEP: true,
  HAS_RUN_STEP: true,
  HAS_POST_RUN_STEP: true,
};

const ASSAY_TO_FEATURE_CONFIG_OVERRIDES: FeatureConfigDict = DEFAULT_FEATURE_CONFIGS;

const RECIPE_TO_FEATURE_CONFIG_OVERRIDES: FeatureConfigDict = DEFAULT_FEATURE_CONFIGS;

const PROCEDURE_PLATFORM_FEATURE_CONFIGS_BY_PROCEDURE_TYPE: {
  [procedureType in ProcedureType]: FeatureConfigDict;
} = {
  [ProcedureType.ASSAY]: ASSAY_TO_FEATURE_CONFIG_OVERRIDES,
  [ProcedureType.RECIPE]: RECIPE_TO_FEATURE_CONFIG_OVERRIDES,
};

export function getProcedurePlatformFeatureConfig(
  feature: ProcedurePlatformFeature,
  procedureType: ProcedureType
): boolean {
  return PROCEDURE_PLATFORM_FEATURE_CONFIGS_BY_PROCEDURE_TYPE[procedureType][feature];
}
